import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class LogicPercent extends DesigntimeComponent {
    static staticName = "Logic: Percent";
    static staticId = "logicPercent";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.params = {
            whole: { key: "url:monthlySpending", value: 1 },
            part: { key: "url:monthlySpending", value: 1 },
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicPercent'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.whole.key != eventParams.key && this.params.part.key != eventParams.key) {
            return;
        }

        if (this.params.whole.key == eventParams.key) {
            this.params.whole.value = parseInt(eventParams.value);
        }
        if (this.params.part.key == eventParams.key) {
            this.params.part.value = parseInt(eventParams.value);
        }

        var percent = 100 * this.params.part.value / this.params.whole.value;
        this.eventBroker.fireValueChanged(this.id, "percent", percent);
        this.eventBroker.fireValueChanged(this.id, "percent_x", componentHelpers.round(percent, 1));
        this.eventBroker.fireValueChanged(this.id, "percent_xx", componentHelpers.round(percent, 2));
    }

    output = [
        { name: "percent", type: "number" },
        { name: "percent_x", type: "number" },
        { name: "percent_xx", type: "number" }];
}

export { LogicPercent }
